<template>
  <div class="gameplan">
    <ContentHeader path-set-type="append" :gameplan-nav="true" />
    <div class="content-wrapper" v-loading="loading">
      <div class="normal_box box_width" v-if="detailList.length>0">
        <div class="item-info">
          <div>
            <div class="pr_title">
              {{detailList[0].themeBasic.themeName}}
            </div>
            <div class="pr_detail">
              <div class="pr_info">
                <div class="display-flex">
                  <div>活动PR：{{detailList[0].themeBasic.gpPrDTO&&detailList[0].themeBasic.gpPrDTO.prNumber}} - {{detailList[0].themeBasic.gpPrDTO&&detailList[0].themeBasic.gpPrDTO.prName}}</div>
                  <div class="pr_brand">{{detailList[0].themeBasic.gpPrDTO&&detailList[0].themeBasic.gpPrDTO.brandName}}</div>
                </div>
              </div>
              <div class="pr_date">活动执行时间：{{detailList[0].themeBasic.themeStartTime | parseTime("{y}-{m}-{d}")}} - {{detailList[0].themeBasic.themeEndTime | parseTime("{y}-{m}-{d}")}} &nbsp;&nbsp;&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
      <el-row>
        <el-col :span="6" class="content-left">
          <div class="trade-container">
            <el-card class="trade-nav-panel">
              <div slot="header" class="clearfix">
                <span class="panel-header">活动渠道</span>
              </div>
              <el-menu :default-active="themeChannelCode" active-text-color="#101010" text-color="#101010">
                <el-menu-item index="all" @click="clickMenu('all')">
                  <span slot="title">全部</span>
                </el-menu-item>
                <el-menu-item
                  v-for="(value, key) in themeChannelMap"
                  :key="key"
                  :index="key"
                  @click="clickMenu(key)"
                >
                  <span slot="title">{{ value }}</span>
                </el-menu-item>
              </el-menu>
            </el-card>
          </div>
        </el-col>
        <el-col :span="18" class="content-right" v-if="detailList.length>0">
          <div class="card-box">
            <div class="card is-hover-shadow" v-for="item of detailList" :key="item.themeLevelCode">
              <div class="item-info-left">
                <div class="first">
                  <div class="first-left">
                    活动渠道：{{item.themeDetail.themeChannelName&&item.themeDetail.themeChannelName.split('|')[1]}}
                    <!-- 活动渠道：{{item.gpThemeDetailDTO&&item.gpThemeDetailDTO.themeChannelName.split('|')[1]}} -->
                  </div>
                  <span v-if="item.themeDetail.themeStyleName">
                    <div class="first-center">活动形式：{{item.themeDetail.themeStyleName}}</div>
                  </span>
                  <span v-if="item.themeDetail.themeLevelName">
                    <div class="first-center">级别：{{item.themeDetail.themeLevelName}}</div>
                  </span>
                </div>
                <div class="second">
                  <div class="second-left">是否需要SPR：{{item.themeDetail&&item.themeDetail.needSpr==0?'否':'是'}}</div>
                  <!-- <div class="second-left">是否需要督导打卡：{{item.themeDetail&&item.themeDetail.needSupervisor==0?'否':'是'}}</div> -->
                </div>

                <div class="third" v-if="item.themeDetail.themeDecorates&&item.themeDetail.themeDecorates.length>0">装饰点位：
                  <span v-for="(decorate,index) of getThemeDecorates(item.themeDetail.themeDecorates)" :key="decorate">
                    {{decorate}} {{index===(item.themeDetail.themeDecorates.length-1)?'':'、'}}
                  </span>
                </div>
                <!-- <div class="third color-grey">
                  IGNITE查询规则：{{getIgnate(item.themeDetail.igniteRuleObj)||'无IGNITE查询规则限制'}}
                </div> -->
              </div>

              <div class="item-info-right">
                <div class="first-right">
                  <span v-if="item.themeDetail&&item.themeDetail.needVerify==1">需要场勘 / </span>
                  <span v-else>不需要场勘 / </span>
                  <span v-if="item.themeDetail&&item.themeDetail.needConstruct==1">需要搭建</span>
                  <span v-else>不需要搭建</span>
                </div>
                <div class="item-info-right-btn" @click="gotoWeb('activity-detail')" >查看详情</div>
              </div>
            </div>
          </div>
          <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :total="total"
              :current-page="queryParams.page" :page-size="queryParams.pageSize"
              @current-change="handleCurrentChange" @size-change="handleSizeChange"/>
          </div>
        </el-col>
        <el-col :span="18" class="content-right" v-else>
          <div class="no-data">暂无数据</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ContentHeader from "@/components/content-header";
import gameplanApi from "@/api/gameplan";
export default {
  name: "activity-management-detail",
  components: {
    ContentHeader,
  },
  data() {
    return {
      queryParams: {
        page: 1,
        pageSize: 10,
        themeChannelCode: '',
        themeId: ''
      },
      total:0,
      detailList: [],
      igniteOptions:{},
      showDialog:false,
      themeChannelCode:'all',
      themeChannelMap:[],
      loading:false
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  // watch:{
  //   '$route' (){
  //     if(this.$route.params.activityType==='all'){
  //       this.queryParams.themeChannelCode = ''
  //     }else {
  //       this.queryParams.themeChannelCode = this.$route.params.activityType
  //     }
  //     this.queryParams.themeId = this.themeId
  //     this.getGameplanThemeDetailList()
  //   }
  // },
  created() {
    this.themeId =  sessionStorage.getItem('themeId') || ''
    this.queryParams.themeId = this.themeId
    this.getGameplanConfigIgniteOptions()
    this.getGameplanThemeDetailList()
  },
  mounted() { },
  methods: {
    async getGameplanThemeDetailList() {
      this.loading = true
      // if ("all" !== this.themeChannelCode) {
      //   this.queryParams.themeChannelCode = this.themeChannelCode;
      // }
      //console.log(this.themeChannelCode);
      this.themeChannelCode==='all'?this.queryParams.themeChannelCode = '':this.queryParams.themeChannelCode = this.themeChannelCode
      const { data } = await gameplanApi.getGameplanThemeDetailList(this.queryParams);
      if (data.resultCode === "0") {
        this.detailList = data.resultData?.detailList || [];
        if (this.themeChannelCode === 'all' ) {
          this.themeChannelMap = data.resultData?.themeChannelMap || [];
        }
        this.total = data.resultData.pageInfo.totalCounts
      }
      this.loading = false
    },
    async getGameplanConfigIgniteOptions() {
      const { data } = await gameplanApi.getGameplanConfigIgniteOptions();
      if (data.resultCode === "0") {
        this.igniteOptions = data.resultData?.igniteOptions || {};
      }
    },
    async handleSOW(themeId){
      const { data } = await gameplanApi.gameplanThemeDownload(themeId);
      if (data.resultCode === "0") {
        this.$alert('推送成功', '提示', {
          confirmButtonText: '确定',
        });
      }
    },
    clickMenu(code) {
      this.themeChannelCode = code;
      this.queryParams.page = 1;
      this.getGameplanThemeDetailList();
    },
    getThemeDecorates(themeDecoratesList) {
      let res = []
      for (let item of themeDecoratesList) {
        res.push(item.decorateName)
      }
      return res
    },
    getIgnate(igniteRuleObj){
      let res = ''
      for(let item in igniteRuleObj){
        let selectedList = igniteRuleObj[item]
        let detail = this.igniteOptions[item]
        if(selectedList&&selectedList.length>0){
          for(let selected of selectedList){
            switch (item) {
              case 'bizForm':
              res.indexOf('| 业态：')===-1?res+='| 业态：':res+=''
                //res+='业态：'
                break;
              case 'channel':
                res.indexOf('| 渠道设置：')===-1?res+='| 渠道设置：':res+=''
                break;
              case 'igniteStatus':
              res.indexOf('IGNATE状态：')===-1?res+='IGNATE状态：':res+=''
               // res+='IGNATE状态：'
                break;
              case 'openStatus':
              res.indexOf('售点状态：')===-1?res+='售点状态：':res+=''
               // res+='售点状态：'
                break;
              case 'pocGrade':
              res.indexOf('| 档次：')===-1?res+='| 档次：':res+=''
               // res+='档次：'
                break;
              case 'salesVolume':
              res.indexOf('| 销售潜力：')===-1?res+='| 销售潜力：':res+=''
                //res+='销售潜力：'
                break;
              default:
                break;
            }
            if(detail&&detail[selected]){
              res+= detail[selected] + " " + (item=="salesVolume"?"":"")
            }
          }
        }
      }
      return res
    },
    queryConfiglist() {
      let params = {
        page: 1,
        pageSize: 5,
        prNumber: "",
        themeName: "",
        brandCode: "",
        subBrandCode: "",
        themeStatus: "",
      };
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getGameplanThemeDetailList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.getGameplanThemeDetailList()
    },
    // 去审批
    gotoWeb(name){
      this.$router.push({
        name,
        query: { themeId:this.themeId },
      });
    },
    goApprove(activityId) {
      this.$router.push({
        name: "activity-management-sale",
        query: { activityId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
}

.trade-nav-panel {
  width: 80%;
  min-height: 400px;
  margin-left: 10%;
  background: $base-white;

  //   .el-menu-item:last-child{
  //     border-bottom: 0;
  //   }
  ::v-deep .el-card__header {
    height: 70px;
    line-height: 35px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  .panel-header {
    font-size: 16px;
    font-weight: 700;
    color: #cd1231;
  }

  ::v-deep .el-menu {
    border-right: 0;
  }

  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }

  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}
.popover-box{
  border: solid 1px rgb(243, 243, 243);
  width: 100%;
}
.assign-title{
  width:100%;
  padding: 10px 0;
  text-align: center;
  background-color: #eeeeee;
}
.assign-context{
  padding: 20px 0;
  margin: 0 5px;
}

.content-wrapper {
  min-height: calc(100vh - 320px) !important;
  font-family: SourceHanSansSC-regular;

  .content-right {
    height: 100%;
    box-sizing: border-box;

    a {
      text-decoration: none;
      color: #000;
    }

    .search {
      .searchForm {
        width: 100%;

        .item {
          width: 120px;
        }

        .item-btn {
          margin-left: 30px;
        }
      }
    }
    .card-box {
      .card {
        padding: 15px 20px;
        background-color: #ffffff;
        border-radius: 10px;
        font-size: 14px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;

        .item-info-left{
  .first {
    display: flex;
    justify-content: flex-start;
    height: 33px;
    line-height: 33px;

    .first-left {
      font-size: 16px;
      font-weight: 600;
      color: #101010;
      text-align: left;
      font-family: SourceHanSansSC-medium;
      margin-right: 10px;
    }

    .first-center {
      height: 19px;
      line-height: 19px;
      margin-top: 3px;
      padding: 3px 5px;
      text-align: center;
      border-radius: 4px;
      font-family: Microsoft Yahei;
      border: 1px solid #cd1231;
      background-color: #ffffff;
      color: #cd1231;
      margin-right: 5px;
    }
  }

  .second {
    display: flex;
    justify-content: flex-start;
    margin-top: 10px;
    font-size: 13px;
    text-align: left;
    color: #101010;
    font-family: SourceHanSansSC-regular;

    .second-left {
      min-width: 160px;
      margin-right: 20px;
    }
  }

  .third {
    line-height: 20px;
    margin-top: 10px;
    font-size: 13px;
    text-align: left;
    font-family: SourceHanSansSC-light;
  }
  .color-grey{
    color: #999999;
  }
}
        .item-info-right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items:flex-end;
          min-width: 180px;
          font-size: 14px;
          text-align: left;
          color: #101010;
          .first-right {
            font-size: 16px;
            font-weight: 600;
            text-align: right;
            font-family: SourceHanSansSC-medium;
            color: #cd1231;
          }
          .last-left {
            .line {
              color: #999999;
              margin: 0 5px;
            }

            .blue {
              color: #409eff;
            }
          }

          .item-info-right-btn {
            cursor: pointer;
            padding: 5px 0;
            width: 100px;
            border-radius: 4px;
            font-size: 14px;
            text-align: center;
            font-family: Microsoft Yahei;
            color: #cd1231;
            border: 1px solid #cd1231;
            //align-items: flex-end;
            margin-left: 10px;
          }
        }
      }
    }

    .pagination {
      position: relative;
      bottom: 0;
      text-align: center;
    }
  }

  .content-left {
    padding-right: $content-middle;
  }
}
.no-data{
  width: 100%;
  text-align: center;
  margin-top: 100px;
}
.box_width{
  width: calc(100% - 50px);
  margin:0 0 20px 28px;
}
.item-info{
    //width: 100%;
    margin: 0 10px;
    .pr_title{
      font-size: $font-18;
      font-weight: 600;
    }
    .pr_detail{
      //width: 100%;
      display: flex;
      justify-content: space-between;
      margin: 10px 0;
      .pr_date{
        display: flex;
        justify-content:flex-end;
        color: grey;
        min-width: 300px;
      }
      .pr_brand{
        font-size: 12px;
        padding: 3px 5px;
        word-break: keep-all;
        height: 12px;
        color: rgb(51, 180, 255);
        border: 1px solid rgb(51, 180, 255);
        border-radius: 4px;
        margin-left: 20px;
        line-height: 12px;
      }
    }
    .display-flex{
      display: flex;
      //text-align: center;
      line-height: 17px;
    }
  }

</style>
